import React, { useState } from 'react';
import { ClipboardCopy, Trash2, Pencil, PlusCircle, PlayCircle, ExternalLink } from 'lucide-react';
import Deployment_IntegrationModal from './Deployment_IntegrationModal';

const integrations = [
  {
    id: 'int001',
    name: 'Chatbot Widget',
    type: 'Iframe',
    description: 'Embed chatbot for customer support.',
    parameters: ['project'],
    accessUrl: '<iframe src="https://yourdomain.com/chatbot?project=invoice_ai" width="100%" height="500px"></iframe>',
    authMethod: 'None',
    visibility: ['All Users'],
    lastUsed: 'Today',
  },
  {
    id: 'int002',
    name: 'Weekly Report API',
    type: 'API Endpoint',
    description: 'Trigger weekly report for finance.',
    parameters: ['project', 'email'],
    accessUrl: 'https://yourdomain.com/api/v1/workflows/trigger',
    authMethod: 'API Key',
    visibility: ['FinanceTeam'],
    lastUsed: 'Yesterday',
  },
  {
    id: 'int003',
    name: 'Trigger Workflow X',
    type: 'Webhook',
    description: 'Trigger workflow externally.',
    parameters: ['workflow_id'],
    accessUrl: 'https://yourdomain.com/webhook/trigger/workflow_x?token=XYZ',
    authMethod: 'Token',
    visibility: ['Admin Only'],
    lastUsed: '2 Days Ago',
  },
];

const Deployments = () => {
  const [search, setSearch] = useState('');

  const filteredData = integrations.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    alert('Copied to clipboard!');
  };
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      {/* Header + Button */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-xl font-semibold text-white">Embeddables & API Access</h2>
          <p className="text-sm text-gray-400">Generate and manage embed codes, API endpoints, and webhooks.</p>
        </div>
        <button onClick={() => setShowModal(true)} className="flex items-center bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-md text-sm shadow">
          <PlusCircle className="w-4 h-4 mr-2" /> Add New Integration
        </button>
      </div>

      {/* Search */}
      <div className="mb-4">
        <input
          type="text"
          placeholder="Search integrations..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full px-4 py-2 rounded-md bg-neutral-800 text-white placeholder-gray-400 focus:outline-none text-sm"
        />
      </div>

      {/* Table */}
      <div className="overflow-x-auto border border-neutral-800 rounded">
        <table className="min-w-full text-sm text-left text-gray-300">
          <thead className="bg-neutral-900 text-gray-400 uppercase">
            <tr>
              <th className="px-4 py-2">Name</th>
              <th className="px-4 py-2">Type</th>
              <th className="px-4 py-2">Description</th>
              <th className="px-4 py-2">Parameters</th>
              <th className="px-4 py-2">Access</th>
              <th className="px-4 py-2">Auth</th>
              <th className="px-4 py-2">Visibility</th>
              <th className="px-4 py-2">Last Used</th>
              <th className="px-4 py-2 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((item) => (
              <tr key={item.id} className="border-t border-neutral-800 hover:bg-neutral-800/30">
                <td className="px-4 py-3">
                  {item.name === 'Chatbot Widget' ? (
                    <a
                      href="/chat"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1 text-cyan-400 hover:underline"
                      title="Open Chatbot Widget"
                    >
                      Chatbot Widget
                      <ExternalLink className="w-4 h-4" />
                    </a>
                  ) : (
                    item.name
                  )}
                </td>

                <td className="px-4 py-3 text-purple-400">{item.type}</td>
                <td className="px-4 py-3">{item.description}</td>
                <td className="px-4 py-3">{item.parameters.join(', ')}</td>
                <td className="px-4 py-3">
                  <button
                    onClick={() => copyToClipboard(item.accessUrl)}
                    className="flex items-center text-indigo-400 hover:text-indigo-300 text-xs"
                  >
                    <ClipboardCopy className="w-4 h-4 mr-1" /> Copy
                  </button>
                </td>
                <td className="px-4 py-3">{item.authMethod}</td>
                <td className="px-4 py-3">{item.visibility.join(', ')}</td>
                <td className="px-4 py-3">{item.lastUsed}</td>
                <td className="px-4 py-3 flex justify-end gap-2">
                  <button className="text-green-400 hover:text-green-300" title="Test">
                    <PlayCircle className="w-4 h-4" />
                  </button>
                  <button className="text-yellow-400 hover:text-yellow-300" title="Edit">
                    <Pencil className="w-4 h-4" />
                  </button>
                  <button className="text-red-400 hover:text-red-300" title="Delete">
                    <Trash2 className="w-4 h-4" />
                  </button>
                </td>
              </tr>
            ))}
            {filteredData.length === 0 && (
              <tr>
                <td colSpan={9} className="text-center py-6 text-gray-500">
                  No integrations found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {showModal && <Deployment_IntegrationModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Deployments;
